import { Identifiable } from './identifiable';
import type { Instance } from 'larvitar/dist/imaging/types';

export class SeriesElement implements Identifiable {
    instance: Instance;

    constructor(instance: Instance) {
        this.instance = instance;
    }

    getId(): string {
        return this.instance['metadata']['x00080018'] || '';
    }

    // TODO verificare se x00200011 o x0020000e
    getSeriesId(): string {
        return this.instance['metadata']['x0020000e'] || '';
    }

    getSeriesDescription(): string {
        return this.instance['metadata']['x0008103e'] || '';
    }

    getSeriesDate(): string {
        return this.instance['metadata']['x00080021'] || '';
    }

    getSeriesTime(): string {
        return this.instance['metadata']['x00080031'] || '';
    }

    getSeriesModality(): string {
        return this.instance['metadata']['x00080060'] || '';
    }

    getSeriesBodyPart(): string {
        return this.instance['metadata']['x00180015'] || '';
    }

    getStudyId(): string {
        return this.instance['metadata']['x0020000d'] || '';
    }

    getStudyDescription(): string {
        return this.instance['metadata']['x00081030'] || '';
    }

    getStudyDate(): string {
        return this.instance['metadata']['x00080020'] || '';
    }

    getStudyTime(): string {
        return this.instance['metadata']['x00080030'] || '';
    }

    getStudyProtocolName(): string {
        return this.instance['metadata']['x00181030'] || '';
    }

    getStudyAccessionId(): string {
        return this.instance['metadata']['x00080050'] || '';
    }

    getPatientId(): string {
        return this.instance['metadata']['x00100020'] || '';
    }

    getPatientName(): string {
        return this.instance['metadata']['x00100010'] || '';
    }

    getPatientSex(): string {
        return this.instance['metadata']['x00100040'] || '';
    }

    getPatientBirthDate(): string {
        return this.instance['metadata']['x00100030'] || '';
    }
}
